import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementKoLocale from 'element-ui/lib/locale/lang/ko'// element-ui lang
import elementZhFtLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang
import elementFrLocale from 'element-ui/lib/locale/lang/fr'// element-ui lang
import elementEsLocale from 'element-ui/lib/locale/lang/es'// element-ui lang
import elementPtLocale from 'element-ui/lib/locale/lang/pt'// element-ui lang
import elementDeLocale from 'element-ui/lib/locale/lang/de'// element-ui lang
import elementItLocale from 'element-ui/lib/locale/lang/it'// element-ui lang
import elementRuLocale from 'element-ui/lib/locale/lang/ru-RU'// element-ui lang
import elementMnLocale from 'element-ui/lib/locale/lang/mn'// element-ui lang
import elementArLocale from 'element-ui/lib/locale/lang/ar'// element-ui lang
import elementThLocale from 'element-ui/lib/locale/lang/th'// element-ui lang
import elementViLocale from 'element-ui/lib/locale/lang/vi'// element-ui lang
import elementIdLocale from 'element-ui/lib/locale/lang/id'// element-ui lang
import elementHuLocale from 'element-ui/lib/locale/lang/hu'// element-ui lang
import elementFaLocale from 'element-ui/lib/locale/lang/fa'// element-ui lang
import elementHeLocale from 'element-ui/lib/locale/lang/he'// element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja'// element-ui lang

import enLocale from './en'
import zhLocale from './zh'
import koLocale from './ko'
import zhFtLocale from './zh-ft'
import {getUrlKey} from '@/utils/index'
import frLocale from './fr'
import esLocale from './es'
import ptLocale from './pt'
import deLocale from './de'
import itLocale from './it'
import ruLocale from './ru'
import mnLocale from './mn'
import arLocale from './ar'
import thLocale from './th'
import viLocale from './vi'
import idLocale from './id'
import huLocale from './hu'
import faLocale from './fa'
import heLocale from './he'
import jaLocale from './ja'


Vue.use(VueI18n)

// 准备翻译的语言环境信息
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  ko: {
    ...koLocale,
    ...elementKoLocale
  },
  zh_ft: {
    ...zhFtLocale,
    ...elementZhFtLocale
  },
  fr:{
    ...frLocale,
    ...elementFrLocale
  },
  es:{
    ...esLocale,
    ...elementEsLocale
  },
  pt:{
    ...ptLocale,
    ...elementPtLocale
  },
  de:{
    ...deLocale,
    ...elementDeLocale
  },
  ru:{
    ...ruLocale,
    ...elementRuLocale
  },
  mn:{
    ...mnLocale,
    ...elementMnLocale
  },
  ar:{
    ...arLocale,
    ...elementArLocale
  },
  th:{
    ...thLocale,
    ...elementThLocale
  },
  vi:{
    ...viLocale,
    ...elementViLocale
  },
  id:{
    ...idLocale,
    ...elementIdLocale
  },
  hu:{
    ...huLocale,
    ...elementHuLocale
  },
  fa:{
    ...faLocale,
    ...elementFaLocale
  },
  it:{
    ...itLocale,
    ...elementItLocale
  },
  he:{
    ...heLocale,
    ...elementHeLocale
  },
  ja:{
    ...jaLocale,
    ...elementJaLocale
  },
}

const i18n = new VueI18n({
  locale: getLang(), // set locale
  messages, // set locale messages
  silentTranslationWarn: true
})

let lang = getUrlKey('lang')
if (lang == "null" || lang == null || lang == undefined) {
} else {
  if (lang == 'zh' || lang == 'en' || lang == 'ko' || lang == 'zh_ft') {
    Cookies.set('language', lang)
  }
}

function getLang() {
  let lang = getUrlKey('lang')
  if (lang == "null" || lang == null || lang == undefined) {
    return Cookies.get('language') || navigatorLanguage()
  } else {
    if (lang == 'zh') {
      Cookies.set('language', 'zh')
    } else if (lang == 'en') {
      Cookies.set('language', 'en')
    } else if (lang == 'ko') {
      Cookies.set('language', 'ko')
    } else if (lang == 'zh_ft') {
      Cookies.set('language', 'zh_ft')
    } else {
      Cookies.set('language', 'en')
    }
    return Cookies.get('language')
  }
}

//获取浏览器的语言
function navigatorLanguage() {
  const JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
  let language = ''
  if (JsSrc == 'zh-cn') {// 中文
    language = 'zh'
  } else if (JsSrc == 'en') {// 英文
    language = 'en'
  } else if (JsSrc == 'ko') { // 韩文
    language = 'ko'
  } else if (JsSrc == 'zh-tw') {// 繁体
    language = 'zh_ft'
  } else {
    language = 'en'
  }

  Cookies.set('language', language)
  if (Cookies.get('language') == "zh") {
    document.title = 'Q-NEX 工作台'
  } else if (Cookies.get('language') == "en") {
    document.title = 'Q-NEX Console'
  } else if (Cookies.get('language') == "ko") {
    document.title = 'Q-NEX Console'
  } else if (Cookies.get('language') == "zh_ft") {
    document.title = 'Q-NEX 工作臺'
  }

  return language
}

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js